module.exports = __webpack_public_path__ + "static/services-image-5_d-f113398bcf7421fc94d3d0ba89c7ce5b.jpg";